const stateCoordinates = {
  "All Stores": {lat: -26.767836, lng: 134.446671, zoom: 32},

  // "New South Wales": { lat: -32.842673960386165, lng: 146.49169925000004, zoom: 8 },
  // "Victoria": { lat: -37.11652798125778, lng: 144.79980507812496, zoom: 6 },
  // "Queensland": { lat: -20.91757400000001, lng: 145.778960875, zoom: 18 },
  // "Western Australia": { lat: -24.893763735744542, lng: 121.93855099999998, zoom: 24 },
  // "South Australia": { lat: -30.000233, lng: 135.000102, zoom: 14 },
  // "Tasmania": { lat: -41.454519, lng: 145.970664, zoom: 6 },
  // "Northern Territory": { lat: -20.132242293708607, lng: 133.42987025, zoom: 16 },
  // "Australian Capital Territory": { lat: -35.473469, lng: 149.012375, zoom: 4 },

  "New South Wales": { lat: -33.8688, lng: 151.2093, zoom: 1 }, // Sydney
  "Victoria": { lat: -37.8136, lng: 144.9631, zoom: 1 }, // Melbourne
  "Queensland": { lat: -27.7150, lng: 153.1939, zoom: 1 }, // Middle Brisbane & GC
  "Western Australia": { lat: -31.9514, lng: 115.8617, zoom: 1 }, // Perth
  "South Australia": { lat: -34.9285, lng: 138.6007, zoom: 1 }, // Adelaide
  "Tasmania": { lat: -42.8826, lng: 147.3257, zoom: 1 }, // Hobart
  "Northern Territory": { lat: -12.4637, lng: 130.8444, zoom: 1 }, // Darwin
  "Australian Capital Territory": { lat: -35.2802, lng: 149.1310, zoom: 1 }, // Canberra
};

function isDeviceMobile() {
  let windowWidth = window.innerWidth;
  return windowWidth < 769;
}

window.addEventListener('DOMContentLoaded', () => {

  const citySelectors = document.querySelectorAll('.store-locator__city-btn');
  const cityStoreDisplays = document.querySelectorAll('.locator-state-wrapper');
  if (citySelectors && cityStoreDisplays) {
    citySelectors.forEach(citySelector => {
      citySelector.addEventListener('click', (e) => {
        const selectedState = citySelector.value;
        const storeCount = citySelector.getAttribute('data-count');
        
        cityStoreDisplays.forEach((display) => {
          display.classList.remove('locator-state-wrapper--shown');
        });
  
        document.querySelector(`.locator-state-wrapper[data-state='${selectedState}']`).classList.add('locator-state-wrapper--shown');
  
        const countMessage = document.querySelector('.store-locator__state-select .store-locator__store-count');
        if (storeCount && countMessage) {
          countMessage.innerHTML = `${storeCount} store${storeCount > 1 ? 's' : ''} near you`
        }
  
        const lat = stateCoordinates[selectedState]?.lat;
        const lng = stateCoordinates[selectedState]?.lng;
        const zoom = stateCoordinates[selectedState]?.zoom;
  
        document.dispatchEvent(new CustomEvent('updateStateSelection', {detail: {lat, lng, zoom}}));
      })
    })
  }
})